// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__31M2c","title":"Header_title__Ptw4b","side":"Header_side__3ZYmu"};